import React, { Component } from "react";
import { message, PageHeader, Col, Row, Spin, Select, Tabs, Alert, Divider, Tag, Tooltip, Upload } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form, FormItem, ButtonItem, InputItem, InputNumberItem,
  SelectItem, ErrorItem, SwitchItem, DatePickerItem,
  SelectDepartamentosItem, SelectPuestosItem, SelectTurnosItem, SelectEmpleadosItem,
  cuentaMask, fmtFechaDia, fechaDiaParaPayload
} from "../../../../Components/Items";
import { PlusOutlined, MinusCircleOutlined, SafetyCertificateOutlined, EyeOutlined, LockOutlined, ScanOutlined, CheckCircleFilled, CloseCircleFilled, MobileOutlined, UpOutlined, DownOutlined, UploadOutlined, DeleteOutlined, UserOutlined } from "@ant-design/icons";
import ModalUsuarioMovil from "../../../../Components/ModalUsuarioMovil";
import SelectPerimetrosChecadaItem from "../../../../Components/SelectPerimetrosChecadaItem";
import FotoRostroEmpleado from "../../../../Components/FotoRostroEmpleado";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import ModalValidacionTimbrado from "../ModalValidacionTimbrado/ModalValidacionTimbrado";
import InfonvitEmpleado from "../../PreNomina/InfonvitEmpleado/InfonvitEmpleado";
import FonacotEmpleado from "../../PreNomina/FonacotEmpleado/FonacotEmpleado";
import MovimientosPermanentesEmpleado from "../../PreNomina/MovimientosPermanentesEmpleado/MovimientosPermanentesEmpleado";
import IncidenciasPermanentesAutonomo from "../../PreNomina/IncidenciasPermanentesEmpleado/IncidenciasPermanentesAutonomo";
import IncapacidadesEmpleado from "../../PreNomina/IncapacidadesEmpleado/IncapacidadesEmpleado";
import VacacionesEmpleado from "../../PreNomina/VacacionesEmpleado/VacacionesEmpleado";
import ModalHistorialRelacionLaboral, { MOTIVO_DESCARTE } from "./ModalHistorialRelacionLaboral";
import ModalReingreso from "../Reingreso/ModalReingreso";
import { etiquetaCausaFiniquito } from "../causaFiniquito";
import {
  regimenIdEsAsimilado, aplicarCambioDeRegimen, percepcionIncluida, alternarPercepcion,
} from "../conceptosAsimilados";
import { calcularSbcParteFija, MOTIVO_SBC_TEXTO } from "../sbc";
import { momentDeFechaDia } from "../../../../Components/fmtFechaDia";
import CalculadoraCurp from "../CalculadoraCurp";
import CalculadoraRfc from "../CalculadoraRfc";
import moment from "moment";
import "../capturaEmpleado.css";

const { Option } = Select;
const { TabPane } = Tabs;

// Campos del formulario que la validación de timbrado lee. Tiene que coincidir
// con CAMPOS_EN_PANTALLA de Controllers/Empleados/validacionTimbrado.controllers.js:
// lo que no esté en las dos listas se valida con el valor guardado, no con el
// capturado. `fechaReingreso` va aquí aunque el formulario no lo capture todavía,
// para que empiece a funcionar solo el día que se agregue el campo.
const CAMPOS_VALIDACION_TIMBRADO = [
  "rfc", "curp", "nombre", "apellidoPaterno", "apellidoMaterno", "extranjeroSinCurp",
  "numSeguridadSocial", "codigo", "sindicalizado",
  "fechaAlta", "fechaReingreso",
  "tipoContratoId", "tipoJornadaId", "tipoRegimenId", "tipoPeriodoId",
  "coloniaId", "registroPatronalId", "regimenFiscalId",
  "salarioDiario", "sbcParteFija", "sbcTopado25UMAS",
  "clabeInterbancaria", "bancoPagoElectronicoId",
  "departamentoId", "puestoId",
];
const LBL = { span: 8 };
const WRP = { span: 16 };

// SBC automático. Cambiar cualquiera de los primeros recalcula la parte fija (salario × factor de
// la tabla de prestaciones); cambiar la variable o la fija a mano sólo recalcula el topado.
const CAMPOS_SBC_PARTE_FIJA = ["salarioDiario", "tipoPrestacionId", "fechaAlta", "fechaReingreso", "baseDeCotizacion"];
const CAMPOS_SBC_TOPADO = ["sbcParteFija", "sbcParteVariable"];
const redondear2 = (n) => Math.round(n * 100) / 100;

// Alta por pasos (modo embebido): los obligatorios de nómina. El asistente dice cuáles aplican
// según la sección a la que se llegó (`camposRequeridos`); estos tres además sólo se le piden a
// quien cotiza en el IMSS, igual que la validación de timbrado (Utils/validacionEmpleadoTimbrado).
const CAMPOS_SOLO_IMSS = ["numSeguridadSocial", "registroPatronalId", "sbcParteFija"];
const mayorACero = (etiqueta) => ({
  validator: (_, v) => (v === null || v === undefined || v === "" || Number(v) > 0
    ? Promise.resolve()
    : Promise.reject(new Error(`${etiqueta} debe ser mayor a cero`))),
});
const REGLAS_REQUERIDO = {
  salarioDiario: [mayorACero("El salario diario")],
  sbcParteFija: [mayorACero("El SBC")],
  numSeguridadSocial: [{ pattern: /^\d{11}$/, message: "El NSS son 11 dígitos" }],
};

const MAX_ARCHIVOS_DOCUMENTOS = 3;
const TIPOS_ARCHIVO_DOCUMENTOS = ["application/pdf", "image/jpeg", "image/png", "image/webp"];

// El código del empleado es numérico en el modelo: cualquier letra que se escriba aquí
// revienta el cast de Mongoose al guardar y al checar duplicados. Se filtra el tecleo
// para que la letra ni siquiera llegue a aparecer en el campo.
const soloDigitos = (e) => String(e?.target?.value ?? "").replace(/[^0-9]/g, "");

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const normFile = (e) => (Array.isArray(e) ? e : e && e.fileList);

const dineroDisplay = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n || 0);

const CredencialCard = ({ icon, titulo, activo, color, detalle, updatedAt }) => (
  <div style={{
    border: `1px solid ${activo ? color + "55" : "#e8e8e8"}`,
    borderRadius: 8, padding: "20px 16px",
    background: activo ? `${color}08` : "#fafafa",
    display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
    minHeight: 150, transition: "all 0.2s",
  }}>
    <div style={{ color: activo ? color : "#bbb", fontSize: 36, lineHeight: 1 }}>{icon}</div>
    <span style={{ fontWeight: 600, fontSize: 14, color: "#333" }}>{titulo}</span>
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {activo ? <CheckCircleFilled style={{ color: "#52c41a" }} /> : <CloseCircleFilled style={{ color: "#d9d9d9" }} />}
      <Tag color={activo ? "success" : "default"} style={{ margin: 0 }}>{activo ? "Registrado" : "Sin datos"}</Tag>
    </div>
    {detalle && <span style={{ fontSize: 11, color: "#888", textAlign: "center" }}>{detalle}</span>}
    {updatedAt && <span style={{ fontSize: 10, color: "#bbb" }}>{moment(updatedAt).format("DD/MM/YYYY HH:mm")}</span>}
  </div>
);

// Además de su ruta, se monta EMBEBIDA como el paso "Demás datos" del alta por pasos
// (Empleados/AltaPorPasos). Con `embebido`:
//   - el id llega en `empleadoId` (no en location.state);
//   - no hay PageHeader ni botón de guardar: navega y guarda el asistente, con la función que
//     recibe en `onRegistrarAcciones({ guardar })`;
//   - `seccion = { encabezado, tab }` dice qué se ve: el bloque de encabezado y/o UNA pestaña,
//     sin barra de pestañas. Lo demás queda oculto con display:none, nunca desmontado, para que
//     sus campos sigan registrados en el formulario y viajen al guardar.
// Sin `embebido` la pantalla es exactamente la de siempre.
class EditarEmpleado extends Component {
  formRef = React.createRef();
  state = {
    loading: false, id: this.props.empleadoId || this.props.location?.state?.id, serieNumero: null, modalUsuarioMovil: false,
    objetoFigurasTranporte: null, objetoPaises: null, objetoPaisesResidencia: null,
    objetoEstados: null, objetoEstadosNacimiento: null, objetoTiposContrato: null,
    objetoTiposPrestacion: null, objetoFormasDePago: null, objetoTiposPeriodo: null,
    objetoTiposJornada: null, objetoRegimenFiscal: null, objetoTipoRegimen: null, objetoBancos: null,
    objetoRegistrosPatronales: null,
    todasMunicipios: [], todasColonias: [], objetoMunicipios: null, objetoColonias: null,
    credenciales: null,
    // Datos crudos para cálculo F10
    todasTiposPrestacion: [],
    todasConceptos: [],
    todasCuentasContables: [],
    objetoConceptos: null,
    filePreviewVisible: false, currentPreviewFile: null,
    validacion: { visible: false, loading: false, resultados: [] },
    // Pestañas de créditos y movimientos: se montan hasta que se visitan por primera vez.
    // Cada una hace su propio fetch, así que montarlas todas al abrir la pantalla costaría
    // media docena de peticiones que casi nunca se usan. Mismo mecanismo que el Sobre Recibo.
    tabsVisitadas: {},
    // Cuál de fechaAlta/fechaReingreso manda, resuelto por el backend
    // (Utils/empleado.utils.js -> explicarInicioRelacionLaboral). La regla NO se reimplementa
    // aquí: esta pantalla sólo pinta el aviso.
    relacionLaboral: null,
    historialRelacionLaboralVisible: false,
    // Lo GUARDADO de la baja y los reingresos: decide si se ofrece "Reingresar", si se pinta el
    // finiquito anterior y si la Fecha Reingreso queda bloqueada (la controla el flujo de Reingreso).
    bajaEmpleado: null,
    reingresos: [],
    modalReingresoVisible: false,
    // Régimen de asimilados a salarios. El catálogo crudo hace falta para leer el
    // c_TipoRegimen del _id seleccionado (el <Option> sólo lo lleva en la etiqueta), y
    // `conceptosGlobalesIds` para poder devolver el juego normal si se sale del régimen.
    todosTiposRegimen: [],
    conceptosGlobalesIds: [],
    asimilados: null,
    esAsimilado: false,
    tipoRegimenIdPrevio: null,
    // SBC automático: la UMA vigente para el tope de 25 UMAs, y el texto que explica el último
    // cálculo debajo del campo.
    umaVigente: null,
    sbcAuto: null,
  };

  /** ¿El campo es obligatorio aquí? Sólo en el alta por pasos (modo embebido). */
  requerido(campo) {
    if (!this.props.embebido || !(this.props.camposRequeridos || []).includes(campo)) return false;
    return CAMPOS_SOLO_IMSS.includes(campo) ? this.sujetoImss() : true;
  }

  reglas(campo) {
    return this.requerido(campo) ? REGLAS_REQUERIDO[campo] : undefined;
  }

  // Sujeto al régimen obligatorio del IMSS: c_TipoRegimen 02, 03 o 04. Sin régimen elegido cuenta
  // como sí, porque el timbrado asume "02" (mismo criterio que esRegimenIMSS del backend).
  sujetoImss() {
    const id = this.state.tipoRegimenIdPrevio;
    if (!id) return true;
    const regimen = this.state.todosTiposRegimen.find((r) => String(r._id) === String(id));
    if (!regimen) return true;
    return ["02", "03", "04"].includes(String(regimen.c_TipoRegimen ?? "").padStart(2, "0"));
  }

  /** Enciende la bandera de la pestaña que se acaba de abrir (una sola vez). */
  onCambiarTab = (key) => {
    if (this.state.tabsVisitadas[key]) return;
    this.setState((prev) => ({ tabsVisitadas: { ...prev.tabsVisitadas, [key]: true } }));
  };

  // Cambio de Tipo de Régimen. El reemplazo de conceptos se propone aquí, con su diff, y se
  // escribe en el formulario para que quede visible y editable antes de guardar.
  onCambiarTipoRegimen = async (value) => {
    const { todosTiposRegimen, esAsimilado, asimilados, todasConceptos, conceptosGlobalesIds } = this.state;
    const seraAsimilado = regimenIdEsAsimilado(value, todosTiposRegimen);

    // Sólo importa cruzar la frontera: cambiar entre dos claves de asimilados (09 → 11) no
    // cambia qué conceptos le tocan.
    if (seraAsimilado === esAsimilado) {
      this.setState({ tipoRegimenIdPrevio: value });
      return;
    }

    const aplicado = await aplicarCambioDeRegimen({
      formRef: this.formRef,
      esAsimiladoNuevo: seraAsimilado,
      asimilados,
      todasConceptos,
      conceptosGlobalesIds,
    });

    if (!aplicado) {
      // Se revierte el select: dejar el régimen puesto con los conceptos viejos es
      // justamente el estado que el guardado rechaza.
      this.formRef.current.setFieldsValue({ tipoRegimenId: this.state.tipoRegimenIdPrevio });
      return;
    }

    this.setState({ esAsimilado: seraAsimilado, tipoRegimenIdPrevio: value });
  };

  // El check "incluir en cada nómina" es derivado: prende y apaga la percepción dentro de
  // conceptosIds, que es el mismo hecho. Ver Empleados/conceptosAsimilados.js.
  onCambiarIncluirAsimilados = (incluir) => {
    const percepcionId = this.state.asimilados?.percepcionId;
    if (!percepcionId) return;
    const actuales = this.formRef.current.getFieldValue("conceptosIds") || [];
    this.formRef.current.setFieldsValue({
      conceptosIds: alternarPercepcion(actuales, percepcionId, incluir),
    });
  };

  /**
   * Aviso de cuál de las dos fechas manda como inicio de la relación laboral.
   *
   * Se pinta SÓLO cuando hay algo que decir —hay un reingreso que gana, o hay uno capturado que se
   * está ignorando—, para no meter ruido en el empleado normal, que es la mayoría. El enlace al
   * historial sí va siempre, para que se pueda consultar sin depender del aviso.
   *
   * La regla no se calcula aquí: llega resuelta del backend en `relacionLaboral`
   * (Utils/empleado.utils.js -> explicarInicioRelacionLaboral), que es la misma que usan el CFDI,
   * el recibo, el aguinaldo y el finiquito. Duplicarla aquí sería una segunda fuente de la verdad.
   */
  renderAvisoRelacionLaboral() {
    const rl = this.state.relacionLaboral;
    const mandaReingreso = rl?.origen === "reingreso";
    const descartado = rl?.reingresoDescartado;
    const { bajaEmpleado, reingresos } = this.state;
    const ultimoReingreso = reingresos.length ? reingresos[reingresos.length - 1] : null;

    // Alineado con los inputs: la etiqueta ocupa 8 de 24 columnas (LBL/WRP).
    return (
      <div style={{ paddingLeft: "33.33%", marginBottom: 8, marginTop: -4 }}>
        {bajaEmpleado && (
          <div
            style={{
              background: "#fff1f0", border: "1px solid #ffccc7", borderRadius: 3,
              padding: "5px 8px", fontSize: 11, marginBottom: 4,
              display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8,
            }}
          >
            <span>
              Dado de baja el <b>{fmtFechaDia(bajaEmpleado.fechaBaja)}</b>
              {bajaEmpleado.causaFiniquito ? ` — ${etiquetaCausaFiniquito(bajaEmpleado.causaFiniquito)}` : ""}
              {bajaEmpleado.finiquitoId ? " (con finiquito)" : " (sin finiquito)"}
            </span>
            {this.props.permisoDeshabilitarEmpleado && (
              <ButtonItem
                htmlType="button"
                size="small"
                type="primary"
                onClick={() => this.setState({ modalReingresoVisible: true })}
              >
                Reingresar
              </ButtonItem>
            )}
          </div>
        )}
        {/* Queda a la vista que ya hubo un finiquito: el reingreso lo quitó del empleado, pero
            su foto vive en `reingresos`. */}
        {!bajaEmpleado && ultimoReingreso && (
          <div
            style={{
              background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: 3,
              padding: "5px 8px", fontSize: 11, marginBottom: 4,
            }}
          >
            Reingresó el <b>{fmtFechaDia(ultimoReingreso.fechaReingreso)}</b>.{" "}
            {ultimoReingreso.finiquito?.finiquitoId ? (
              <>
                Tuvo finiquito el <b>{fmtFechaDia(ultimoReingreso.finiquito.fechaBaja || ultimoReingreso.fechaBaja)}</b>
                {ultimoReingreso.causaFiniquito ? ` (${etiquetaCausaFiniquito(ultimoReingreso.causaFiniquito)}` : " ("}
                {`, neto ${dineroDisplay(ultimoReingreso.finiquito.totalNeto)})`}
              </>
            ) : (
              <>
                Su baja anterior fue el <b>{fmtFechaDia(ultimoReingreso.fechaBaja)}</b>, sin finiquito.
              </>
            )}
            {reingresos.length > 1 && ` Lleva ${reingresos.length} reingresos.`}
          </div>
        )}
        {mandaReingreso && (
          <div
            style={{
              background: "#fffbe6", border: "1px solid #ffe58f", borderRadius: 3,
              padding: "5px 8px", fontSize: 11, marginBottom: 4,
            }}
          >
            <div>
              Inicio de relación laboral: <b>{fmtFechaDia(rl.inicio)}</b>
              <Tag color="gold" style={{ marginLeft: 6 }}>manda el reingreso</Tag>
            </div>
            <div style={{ color: "#666", marginTop: 2 }}>
              Con lo guardado hoy, es la fecha que usan el CFDI de nómina, el recibo, el aguinaldo
              y el finiquito — no la fecha de alta.
            </div>
          </div>
        )}
        {descartado && (
          <div
            style={{
              background: "#fff1f0", border: "1px solid #ffccc7", borderRadius: 3,
              padding: "5px 8px", fontSize: 11, marginBottom: 4,
            }}
          >
            La fecha de reingreso capturada <b>se ignora</b> porque{" "}
            {MOTIVO_DESCARTE[descartado] || "no es utilizable"}. Se usa la fecha de alta.
          </div>
        )}
        <span
          role="button"
          tabIndex={0}
          onClick={() => this.setState({ historialRelacionLaboralVisible: true })}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.setState({ historialRelacionLaboralVisible: true });
            }
          }}
          style={{ fontSize: 11, color: "#00BFD6", cursor: "pointer" }}
        >
          Ver historial de relación laboral
        </span>
      </div>
    );
  }

  componentDidMount() {
    this.consultarTodo();
    window.addEventListener("keydown", this.onKeyDown);
    if (this.props.embebido) this.props.onRegistrarAcciones?.({ guardar: this.guardarEmbebido });
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
    clearTimeout(this.timerSbc);
  }

  onKeyDown = (e) => {
    if (e.key === "F10") { e.preventDefault(); this.calcularSBC(); }
  };

  // Lo que hay CAPTURADO en el formulario, no lo guardado. Se manda al validar
  // para que corregir un dato y darle a "Validar en SAT" reporte el dato nuevo:
  // sin esto la validación leía el documento de la base y seguía marcando el
  // error que el usuario acababa de arreglar en pantalla.
  //
  // Sólo los campos que la validación lee, nunca el formulario completo: ahí
  // viven `documentos` y `credencialesReloj`, que llevan archivos en base64.
  datosEnPantalla() {
    const valores = this.formRef.current?.getFieldsValue(true) || {};
    const datos = {};
    for (const campo of CAMPOS_VALIDACION_TIMBRADO) {
      if (Object.prototype.hasOwnProperty.call(valores, campo)) {
        const valor = valores[campo];
        datos[campo] = moment.isMoment(valor) ? valor.toISOString() : valor;
      }
    }
    return datos;
  }

  // Revisa los datos que el CFDI de nómina necesita y consulta el padrón del SAT.
  validarParaTimbrado() {
    this.setState({ validacion: { visible: true, loading: true, resultados: [] } });
    axios
      .post("empleados/validarEmpleadoParaTimbrado",
        { empresaId: this.props.empresaId, empleadoId: this.state.id, empleadoEnPantalla: this.datosEnPantalla() },
        { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const { success, ...resultado } = res.data;
          this.setState({ validacion: { visible: true, loading: false, resultados: [resultado] } });
        } else {
          this.setState({ validacion: { visible: false, loading: false, resultados: [] } });
          message.error(res.data.message || "No se pudo validar el empleado");
        }
      })
      .catch(() => {
        this.setState({ validacion: { visible: false, loading: false, resultados: [] } });
        message.error("Error al validar los datos del empleado");
      });
  }

  // El CFDI de prueba con el que se validó. Manda los mismos datos de pantalla:
  // si el XML se armara con lo guardado, compararlo contra el resultado de la
  // validación no diría nada.
  descargarXmlPrueba() {
    axios
      .post("empleados/xmlPruebaEmpleado",
        { empresaId: this.props.empresaId, empleadoId: this.state.id, empleadoEnPantalla: this.datosEnPantalla() },
        { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const blob = new Blob([res.data.xml], { type: "application/xml" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = res.data.nombreArchivo || "prueba.xml";
          a.click();
          URL.revokeObjectURL(url);
        } else {
          message.error(res.data.message || "No se pudo generar el XML de prueba");
        }
      })
      .catch(() => message.error("Error al descargar el XML de prueba"));
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios.post("empleados/datosParaEmpleado", { empresaId: this.props.empresaId, empleadoId: this.state.id }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status === 404) return;
        const s = {
          objetoFigurasTranporte: res.data.figurasTranporte?.map((v) => <Option value={v._id} key={v._id}>{v.Clave + " - " + v.Descripcion}</Option>),
          objetoPaises: res.data.paises?.map((v) => <Option value={v._id} key={v._id}>{v.nombre + " - " + v.abreviatura}</Option>),
          objetoPaisesResidencia: res.data.paisesResidencia?.map((v) => <Option value={v._id} key={v._id}>{v.nombre + " - " + v.abreviatura}</Option>),
          objetoEstados: res.data.estados?.map((v) => <Option value={v._id} key={v._id}>{v.nombre + " - " + v.abreviatura}</Option>),
          objetoEstadosNacimiento: res.data.estados?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
          relacionLaboral: res.data.relacionLaboral || null,
          umaVigente: res.data.umaVigente || null,
        };
        if (this.props.nomina) {
          Object.assign(s, {
            objetoTiposContrato: res.data.tiposContrato?.map((v) => <Option value={v._id} key={v._id}>{v.c_TipoContrato + " - " + v.Descripcion}</Option>),
            objetoTiposPrestacion: res.data.tiposPrestacion?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
            todasTiposPrestacion: res.data.tiposPrestacion || [],
            objetoFormasDePago: res.data.formasDePago?.map((v) => <Option value={v._id} key={v._id}>{v.c_FormaPago + ' - ' + v.descripcion}</Option>),
            objetoTiposPeriodo: res.data.tiposPeriodo?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
            objetoTiposJornada: res.data.tiposJornada?.map((v) => <Option value={v._id} key={v._id}>{v.c_TipoJornada + " - " + v.Descripcion}</Option>),
            objetoRegimenFiscal: res.data.regimenFiscal?.map((v) => <Option value={v._id} key={v._id}>{v.c_RegimenFiscal + " - " + v.descripcion}</Option>),
            objetoTipoRegimen: res.data.tiposDeRegimenes?.map((v) => <Option value={v._id} key={v._id}>{v.c_TipoRegimen + " - " + v.descripcion}</Option>),
            objetoBancos: res.data.bancos?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
            objetoRegistrosPatronales: res.data.registrosPatronales?.map((v) => <Option value={v._id} key={v._id}>{v.registroPatronalIMSS}</Option>),
            todasConceptos: res.data.conceptosNomina || [],
            todasCuentasContables: res.data.cuentasContables || [],
            todosTiposRegimen: res.data.tiposDeRegimenes || [],
            asimilados: res.data.asimilados || null,
            // El juego normal de la empresa, para poder devolvérselo si el empleado deja
            // de ser asimilado.
            conceptosGlobalesIds: (res.data.conceptosNomina || [])
              .filter((c) => c.estado === 1 && c.automaticoGlobal === true)
              .map((c) => c._id),
          });
        }
        const data = { ...res.data.empleado };
        if (!data) return;
        s.bajaEmpleado = data.fechaBaja
          ? { fechaBaja: data.fechaBaja, causaFiniquito: data.causaFiniquito || null, finiquitoId: data.finiquitoId || null }
          : null;
        s.reingresos = data.reingresos || [];
        // El empleado puede venir YA con régimen asimilado: el estado tiene que arrancar
        // en sintonía o la pestaña Conceptos no pintaría su aviso ni el check.
        if (data.tipoRegimenId) {
          s.esAsimilado = regimenIdEsAsimilado(data.tipoRegimenId, res.data.tiposDeRegimenes || []);
          s.tipoRegimenIdPrevio = data.tipoRegimenId;
        }
        if (data.serieNumero) this.setState({ serieNumero: data.serieNumero });
        else if (data.serie && data.numero) this.setState({ serieNumero: `${data.serie}${data.numero}` });
        if (data.estadoId) this.onChangeEstado(data.estadoId, true);
        if (data.municipioId) this.onChangeMunicipio(data.municipioId, true);
        if (data.credencialesReloj) this.setState({ credenciales: data.credencialesReloj });
        if (data.documentos?.length > 0) {
          data.documentos = data.documentos.map((doc) => ({
            ...doc,
            vencimiento: doc.vencimiento ? moment(doc.vencimiento) : null,
            // Sin url, para que ModalPrevisualizarArchivos lo lea del backend y detecte el mime real
            archivo: doc.archivo?.url
              ? [{
                uid: `emp-doc-${doc.archivo.url}`,
                name: doc.archivo.name,
                status: "done",
                cargadoDesdeBackend: true,
                urlRelativa: doc.archivo.url,
              }]
              : [],
          }));
          if (data.chofer) {
            const idx = data.documentos.findIndex((d) => d.descripcion === data.numLicencia);
            if (idx !== -1) { const docLic = data.documentos[idx]; if (!data.vigenciaLicencia && docLic.vencimiento) data.vigenciaLicencia = docLic.vencimiento; data.documentos.splice(idx, 1); }
          }
        }
        const { credencialesReloj, serie, numero, serieNumero, ...dataParaForm } = data;
        this.formRef.current.setFieldsValue({
          ...dataParaForm,
          vigenciaLicencia: data.vigenciaLicencia ? moment(data.vigenciaLicencia) : null,
          // momentDeFechaDia y no moment(): las que guardó el importador quedaron a medianoche UTC,
          // en hora local se veían un día antes y fechaDiaParaPayload guardaba ESE día al salvar.
          fechaAlta: momentDeFechaDia(data.fechaAlta),
          // Sin esta línea entraría al DatePicker como string ISO crudo por el spread de
          // `dataParaForm`, que sólo convierte las fechas que están listadas aquí.
          fechaReingreso: momentDeFechaDia(data.fechaReingreso),
          fechaNacimiento: data.fechaNacimiento ? moment(data.fechaNacimiento) : null,
          fechaSalarioVariable: data.fechaSalarioVariable ? moment(data.fechaSalarioVariable) : null,
          fechaSalarioPromedio: data.fechaSalarioPromedio ? moment(data.fechaSalarioPromedio) : null,
          fechaSalarioDiario: data.fechaSalarioDiario ? moment(data.fechaSalarioDiario) : null,
          fechaSalarioIntegrado: data.fechaSalarioIntegrado ? moment(data.fechaSalarioIntegrado) : null,
        });
        this.setState(s);
      });
    this.setState({ loading: false });
  }

  onChangeEstado(value, inicial) {
    if (!inicial) { this.formRef.current.setFieldsValue({ municipioId: undefined, coloniaId: undefined }); this.setState({ objetoMunicipios: null, objetoColonias: null }); }
    axios.post("municipios/selectMunicipios", { estadoId: value }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ todasMunicipios: res.data, objetoMunicipios: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>) }); });
  }

  onChangeMunicipio(value, inicial) {
    if (!inicial) { this.formRef.current.setFieldsValue({ coloniaId: undefined }); this.setState({ objetoColonias: null }); }
    axios.post("colonias/selectColonias", { municipioId: value }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ todasColonias: res.data, objetoColonias: res.data.map((v) => <Option value={v._id} key={v._id}>{v.cp + " - " + v.nombre}</Option>) }); });
  }

  onSearchColonia(value) {
    if (value.toString().length === 5) {
      axios.post("colonias/buscarCP", { cp: value }, { headers: this.props.headersToken })
        .then((res) => {
          if (res.data.status === 404) { message.info("No se encontró el código postal"); }
          else { this.formRef.current.setFieldsValue({ paisId: res.data.paisId, estadoId: res.data.estadoId, municipioId: res.data.municipioId, coloniaId: res.data.colonias && res.data.colonias.length > 0 ? res.data.colonias[0]._id : undefined }); this.onChangeEstado(res.data.estadoId, true); this.onChangeMunicipio(res.data.municipioId, true); }
        });
    }
  }

  onSelectColoniaId(coloniaId) {
    const colonia = this.formRef.current.getFieldValue("colonia");
    if (!colonia) { const nombre = this.state.todasColonias.find((c) => c._id.toString() === coloniaId.toString())?.nombre; this.formRef.current.setFieldsValue({ colonia: nombre }); }
  }

  // ── F10: Calcular SBC ────────────────────────────────────────────────────
  // El cálculo vive en Pages/Panel/Empleados/sbc.js, compartido con Agregar Empleado, Aumento de
  // Sueldo y —como gemelo— con Utils/prestaciones.utils.js del backend, que es quien pinta la
  // columna SBC del listado y corre la revisión automática. Si este botón tuviera su propia
  // copia, podría contradecir a la columna para el mismo empleado.
  calcularSBC() {
    const vals = this.formRef.current.getFieldsValue();
    const { tipoPrestacionId, fechaAlta, fechaReingreso, salarioDiario } = vals;

    if (!tipoPrestacionId) {
      message.warning("Selecciona un Tipo de Prestación antes de calcular el SBC.");
      return;
    }

    const tipoPrestacion = this.state.todasTiposPrestacion.find(
      (t) => t._id.toString() === tipoPrestacionId.toString()
    );
    if (!tipoPrestacion) {
      message.error("No se encontró el Tipo de Prestación seleccionado.");
      return;
    }

    // A propósito NO se le pasa `baseDeCotizacion`: la revisión automática deja fuera a los de
    // salario variable puro porque ahí la parte fija sale del promedio del bimestre, pero este
    // botón es una petición explícita del usuario y debe calcular lo que se le pide.
    const { sbc, anios, factor, motivo } = calcularSbcParteFija({
      empleado: { fechaAlta, fechaReingreso },
      tipoPrestacion,
      salarioDiario,
    });

    if (!sbc) {
      const detalle = MOTIVO_SBC_TEXTO[motivo] || "No se pudo calcular el SBC.";
      if (motivo === "sinFilaAplicable") {
        message.warning(`Con ${anios} año(s) de antigüedad no hay fila aplicable en "${tipoPrestacion.nombre}". Verifica que la tabla cubra esa antigüedad.`);
      } else {
        message.warning(detalle);
      }
      return;
    }

    const topado = this.sbcTopado(sbc, vals.sbcParteVariable);
    this.formRef.current.setFieldsValue({ sbcParteFija: sbc, ...(topado !== null ? { sbcTopado25UMAS: topado } : {}) });
    message.success(`SBC calculado: $${sbc} (Antigüedad: ${anios} año(s), Factor: ${factor})`, 4);
  }

  // ── SBC automático ─────────────────────────────────────────────────────────
  // Al capturar el salario diario (o cambiar la prestación, las fechas o la base de cotización)
  // el SBC se calcula solo, con la misma fórmula de F10. A diferencia de F10 aquí SÍ se le pasa
  // `baseDeCotizacion`: a un salario variable puro no se le pisa la parte fija en silencio.
  // Va con un retraso corto para no recalcular (ni re-pintar esta pantalla) en cada tecla.
  onValoresCambiados = (cambiados) => {
    if (!this.props.nomina) return;
    const claves = Object.keys(cambiados || {});
    const conParteFija = claves.some((k) => CAMPOS_SBC_PARTE_FIJA.includes(k));
    if (!conParteFija && !claves.some((k) => CAMPOS_SBC_TOPADO.includes(k))) return;
    this.sbcConParteFija = this.sbcConParteFija || conParteFija;
    clearTimeout(this.timerSbc);
    this.timerSbc = setTimeout(() => {
      const conFija = this.sbcConParteFija;
      this.sbcConParteFija = false;
      this.recalcularSbc(conFija);
    }, 400);
  };

  // Si hay un recálculo pendiente (se tecleó el sueldo y se guardó de inmediato), lo corre ya.
  // Regresa true si corrió, para que quien guarda vuelva a leer el SBC del formulario.
  correrSbcPendiente() {
    if (!this.timerSbc) return false;
    clearTimeout(this.timerSbc);
    this.timerSbc = null;
    const conFija = this.sbcConParteFija;
    this.sbcConParteFija = false;
    this.recalcularSbc(conFija);
    return true;
  }

  recalcularSbc(conParteFija) {
    this.timerSbc = null;
    const form = this.formRef.current;
    if (!form) return;
    const vals = form.getFieldsValue();
    let fija = Number(vals.sbcParteFija) || 0;
    const cambios = {};

    if (conParteFija) {
      const tipoPrestacion = this.state.todasTiposPrestacion.find(
        (t) => String(t._id) === String(vals.tipoPrestacionId)
      );
      const { sbc, anios, factor, motivo } = calcularSbcParteFija({
        empleado: { fechaAlta: vals.fechaAlta, fechaReingreso: vals.fechaReingreso, baseDeCotizacion: vals.baseDeCotizacion },
        tipoPrestacion,
        salarioDiario: vals.salarioDiario,
      });
      if (sbc) {
        fija = sbc;
        cambios.sbcParteFija = sbc;
        this.setState({ sbcAuto: `Calculado: salario × factor ${factor} (${anios} año(s) en la tabla)` });
      } else {
        this.setState({ sbcAuto: `No se calculó solo: ${MOTIVO_SBC_TEXTO[motivo] || "faltan datos"}` });
      }
    }

    const topado = this.sbcTopado(fija, vals.sbcParteVariable);
    if (topado !== null) cambios.sbcTopado25UMAS = topado;
    if (Object.keys(cambios).length) form.setFieldsValue(cambios);
  }

  // SBC topado a 25 UMAs = fija + variable con ese tope, igual que el motor de nómina. Sin UMA en
  // las tablas de nómina no se topa (el motor tampoco). null = no hay de qué calcularlo.
  sbcTopado(fija, variable) {
    const base = (Number(fija) || 0) + (Number(variable) || 0);
    if (base <= 0) return null;
    const uma = Number(this.state.umaVigente) || 0;
    return redondear2(uma > 0 ? Math.min(base, 25 * uma) : base);
  }

  onFinishFailed = (e) => { ErrorItem(e); };

  // Guardado que dispara el asistente (modo embebido), una vez por sección. No pasa por
  // form.submit(): el Form de la casa ignora un segundo onFinish durante 5 s y el asistente guarda
  // en cada "Siguiente". Regresa true sólo si se guardó.
  guardarEmbebido = async () => {
    this.correrSbcPendiente();
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch (e) {
      this.onFinishFailed(e);
      const campo = e?.errorFields?.[0]?.name;
      this.props.onCampoConError?.(Array.isArray(campo) ? campo[0] : campo);
      return false;
    }
    return this.onFinish(values);
  };

  // ── Archivos de los documentos del empleado ────────────────────────────────
  beforeUploadDocumento = (file, rowName) => {
    if (!TIPOS_ARCHIVO_DOCUMENTOS.includes(file.type)) {
      message.error(`${file.name} debe ser un PDF o una imagen (jpg, png, webp)`);
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 >= 10) {
      message.error(`${file.name} excede el tamaño máximo de 10MB`);
      return Upload.LIST_IGNORE;
    }
    const documentos = this.formRef.current.getFieldValue("documentos") || [];
    const esteRenglonYaTiene = documentos[rowName]?.archivo?.length > 0;
    const totalConArchivo = documentos.filter((d) => d?.archivo?.length > 0).length;
    if (!esteRenglonYaTiene && totalConArchivo >= MAX_ARCHIVOS_DOCUMENTOS) {
      message.error(`Solo se permiten ${MAX_ARCHIVOS_DOCUMENTOS} archivos por empleado`);
      return Upload.LIST_IGNORE;
    }
    return false; // no se sube, se queda en el fileList hasta guardar
  };

  handlePreviewDocumento = (file) => { this.setState({ currentPreviewFile: file, filePreviewVisible: true }); };
  handleCloseFilePreview = () => { this.setState({ filePreviewVisible: false, currentPreviewFile: null }); };

  // Convierte el fileList de cada documento al { name, url } que espera el backend
  async archivosDocumentosParaGuardar(documentos) {
    return Promise.all(
      documentos.map(async (doc) => {
        const item = doc?.archivo?.[0];
        if (!item) return { ...doc, archivo: null };
        if (item.originFileObj instanceof Blob) {
          return { ...doc, archivo: { name: item.name, url: await getBase64(item.originFileObj) } };
        }
        return { ...doc, archivo: { name: item.name, url: item.urlRelativa } };
      })
    );
  }

  onFinish = async (values) => {
    // Un SBC automático que no alcanzó a correr se aplica antes de armar lo que se guarda.
    if (this.correrSbcPendiente()) {
      values = { ...values, ...this.formRef.current.getFieldsValue(["sbcParteFija", "sbcTopado25UMAS"]) };
    }
    this.setState({ loading: true });
    const datosFinales = { ...values, empleadoId: this.state.id, empresaId: this.props.empresaId };
    // El backend hace `$set: req.body`, y JSON.stringify borra las claves con `undefined`:
    // si el Tipo Periodo se limpia con la "x" hay que mandar null explícito o el campo se
    // queda con el valor viejo en Mongo. El guard de `nomina` es el mismo que decide si el
    // campo se renderiza: sin él, `values` no trae la clave y mandar null lo borraría solo.
    if (this.props.nomina) datosFinales.tipoPeriodoId = values.tipoPeriodoId || null;
    // Las dos fechas-día del inicio de la relación laboral van como "YYYY-MM-DD" para que el
    // backend las ancle al mediodía y ninguna pantalla las pueda leer un día corrida. Y en el
    // caso del reingreso el `null` explícito es imprescindible: uno equivocado (o el 30/12/1899
    // que dejó el importador externo) le gana a la fecha de alta en el CFDI y en el finiquito, así
    // que la "x" del campo TIENE que poder borrarlo — con `undefined` el $set no lo toca.
    datosFinales.fechaAlta = fechaDiaParaPayload(values.fechaAlta);
    datosFinales.fechaReingreso = fechaDiaParaPayload(values.fechaReingreso);
    if (!datosFinales.documentos) datosFinales.documentos = [];
    if (!datosFinales.telefonos) datosFinales.telefonos = [];
    if (!datosFinales.contactosEmergencia) datosFinales.contactosEmergencia = [];
    datosFinales.documentos = await this.archivosDocumentosParaGuardar(datosFinales.documentos);
    if (datosFinales.chofer) datosFinales.documentos.unshift({ descripcion: datosFinales.numLicencia || "Licencia", tipo: "Licencia de Chofer", vencimiento: datosFinales.vigenciaLicencia });
    // Regresa si se guardó: lo usa el asistente del alta por pasos (guardarEmbebido). La ruta
    // normal lo ignora.
    return axios.post("empleados/editarEmpleado", datosFinales, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          // Embebido no hay mensaje ni regreso: el asistente avisa y decide a dónde ir.
          if (!this.props.embebido) { message.success("Empleado editado exitosamente"); this.props.history.goBack(); }
          return true;
        }
        message.error(res.data.message || "Error, no se pudo guardar la información");
        return false;
      })
      .catch((err) => {
        // Fuera del asistente se comporta como siempre (el error sigue su curso).
        if (!this.props.embebido) throw err;
        message.error("Error, no se pudo guardar la información");
        return false;
      })
      .finally(() => this.setState({ loading: false }));
  };

  // ── Primer tab: campos de General + campos de nómina si aplica ─────────────
  renderPrimerTab() {
    const { nomina } = this.props;
    return (
      <>
        {(!nomina || this.props.modulosMezcal) && (
          <Row gutter={24}>
            {!nomina && (
              <Col span={12}>
                <FormItem name="externo" label="Externo" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP} tooltip="Al activar, la persona no contará para efectos de la empresa">
                  <SwitchItem />
                </FormItem>
              </Col>
            )}
            {this.props.modulosMezcal && (
              <Col span={12}>
                <FormItem name="responsableMezcal" label="Resp. Mezcal" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
              </Col>
            )}
          </Row>
        )}
        <Row gutter={24}>
          <Col span={12}>
            <FormItem name="extranjero" label="Extranjero" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => getFieldValue("extranjero") && (
                <>
                  <FormItem label="N° Reg. ID Tributario" name="registroIDTributario" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="N° Registro ID Tributario" /></FormItem>
                  <FormItem label="Residencia Fiscal" name="paisResidenciaId" margin required labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Residencia Fiscal">{this.state.objetoPaisesResidencia}</SelectItem></FormItem>
                </>
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem name="chofer" label="Chofer" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => getFieldValue("chofer") && (
                <>
                  <FormItem label="Figura Transporte" name="figuraTransporteId" margin required labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Figura Transporte">{this.state.objetoFigurasTranporte}</SelectItem></FormItem>
                  <FormItem label="N° Licencia" name="numLicencia" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="N° Licencia" /></FormItem>
                  <FormItem label="Vigencia Licencia" name="vigenciaLicencia" margin required labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Vigencia" /></FormItem>
                </>
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <FormItem label="Departamento" name="departamentoId" margin labelCol={LBL} wrapperCol={WRP}>
              <SelectDepartamentosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Departamento" onChange={(v) => this.formRef.current.setFieldsValue({ departamentoId: v })} />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Puesto" name="puestoId" margin labelCol={LBL} wrapperCol={WRP}>
              <SelectPuestosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Puesto" onChange={(v) => this.formRef.current.setFieldsValue({ puestoId: v })} />
            </FormItem>
          </Col>
        </Row>
        {nomina && (
          <>
            <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 4 }}>Nómina</Divider>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem label="Tipo Prestación" name="tipoPrestacionId" margin required={this.requerido("tipoPrestacionId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de Prestación">{this.state.objetoTiposPrestacion}</SelectItem></FormItem>
                <FormItem label="Base de Pago" name="basePago" margin labelCol={LBL} wrapperCol={WRP}>
                  <SelectItem placeholder="Base de pago"><Option value={1}>Sueldo</Option><Option value={2}>Comisión</Option><Option value={3}>Destajo</Option><Option value={4}>Sueldo-Comisión</Option><Option value={5}>Sueldo-Destajo</Option></SelectItem>
                </FormItem>
                <FormItem label="Forma de Pago" name="formaDePagoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Forma de pago">{this.state.objetoFormasDePago}</SelectItem></FormItem>
                <FormItem label="Turno de Trabajo" name="turnoId" margin labelCol={LBL} wrapperCol={WRP}>
                  <SelectTurnosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Turno de trabajo" onChange={(v) => this.formRef.current.setFieldsValue({ turnoId: v })} />
                </FormItem>
                <FormItem label="Tipo de Jornada" name="tipoJornadaId" margin required={this.requerido("tipoJornadaId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de jornada">{this.state.objetoTiposJornada}</SelectItem></FormItem>
                <FormItem label="Régimen Fiscal" name="regimenFiscalId" margin required={this.requerido("regimenFiscalId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Régimen fiscal">{this.state.objetoRegimenFiscal}</SelectItem></FormItem>
                <FormItem label="Tipo de Régimen" name="tipoRegimenId" margin required={this.requerido("tipoRegimenId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de régimen" onChange={this.onCambiarTipoRegimen}>{this.state.objetoTipoRegimen}</SelectItem></FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="N° FONACOT" name="numeroFONACOT" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="N° FONACOT" min={0} /></FormItem>
                <FormItem label="AFORE" name="afore" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="AFORE" min={0} /></FormItem>
                <FormItem label="Expediente" name="expediente" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Expediente" /></FormItem>
                <FormItem label="Líder Directo" name="liderDirectoId" margin labelCol={LBL} wrapperCol={WRP}>
                  <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Líder directo" excluirId={this.state.id} onChange={(v) => this.formRef.current.setFieldsValue({ liderDirectoId: v })} />
                </FormItem>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }

  render() {
    const { nomina, controlAsistencia, embebido } = this.props;
    // Qué muestra el modo embebido (alta por pasos). Fuera de él no se usa.
    const seccion = this.props.seccion || { encabezado: true, tab: "1" };
    const { credenciales, serieNumero } = this.state;
    // Algunos relojes mandan varias plantillas de rostro (credenciales.rostros);
    // los empleados capturados con relojes viejos solo tienen el campo legacy
    // singular `rostro`. Se combinan para mostrar el estado real.
    const rostros = credenciales?.rostros?.length
      ? credenciales.rostros
      : (credenciales?.rostro?.tmpEnc ? [credenciales.rostro] : []);
    const tieneRostro = rostros.length > 0;
    const ultimoRostro = rostros.length ? rostros[rostros.length - 1] : null;
    const huellas = credenciales?.huellas || [];
    const tienePassword = !!credenciales?.passwordEnc;
    const statusGeneral = credenciales?.status || "sin_datos";

    const thStyle = {
      border: "1px solid gray",
      background: "var(--color-background-secondary)",
      padding: "6px 10px",
      fontSize: 12,
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      textAlign: "left",
    };
    const tdStyle = {
      border: "1px solid gray",
      padding: "4px 8px",
      verticalAlign: "middle",
    };

    return (
      <>
        {!embebido && (
          <PageHeader
            onBack={() => this.props.history.goBack()}
            title="Editar Empleado"
            className="captura-empleado-cabecera"
            avatar={{ icon: <UserOutlined /> }}
            style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
            extra={
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                {nomina && (
                  <ButtonItem type="primary" azul icon={<SafetyCertificateOutlined />} onClick={this.validarParaTimbrado.bind(this)}>
                    Validar en SAT
                  </ButtonItem>
                )}
                {this.props.appMovil && this.props.permisoUsuarioMovil && (
                  <ButtonItem blanco icon={<MobileOutlined />} onClick={() => this.setState({ modalUsuarioMovil: true })}>
                    Usuario Móvil
                  </ButtonItem>
                )}
              </div>
            }
          />
        )}
        {/* Estilo de captura compartido con Agregar Empleado y el alta por pasos (../capturaEmpleado.css). */}
        <div
          className={embebido ? "captura-empleado" : "captura-empleado captura-empleado-tarjeta"}
          style={{ backgroundColor: "white", paddingLeft: embebido ? 0 : 20, paddingRight: embebido ? 0 : 20 }}
        >
          <Spin spinning={this.state.loading}>
            <Form ref={this.formRef} name="editarEmpleado" layout
              bottom={embebido ? undefined : <ButtonItem htmlType="submit" cyan style={{ display: "block", margin: "0 0 0 auto" }}>Editar Empleado</ButtonItem>}
              onFinish={this.onFinish} onFinishFailed={this.onFinishFailed} onValuesChange={this.onValoresCambiados}>

              {/* ENCABEZADO. Embebido va sin caja: la tarjeta la pone el asistente. */}
              <div
                className={embebido ? undefined : "captura-empleado-encabezado"}
                style={embebido && !seccion.encabezado ? { display: "none" } : undefined}
              >
                <Row gutter={24} align="top" wrap={false}>
                  {/* Embebido, la foto y la identidad (código, nombre, RFC, CURP, correo) ya se
                      capturaron en el paso 1 del alta: se ocultan, pero siguen montadas. */}
                  <Col flex="170px" className="captura-empleado-foto" style={embebido ? { display: "none" } : undefined}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                      {/* noStyle: sin la rejilla etiqueta/campo del formulario, que la hacía más
                          ancha que su columna. Sigue ligada al campo `fotoRostro`. */}
                      <FormItem name="fotoRostro" noStyle>
                        <FotoRostroEmpleado />
                      </FormItem>
                      {serieNumero && <Tag color="blue" style={{ fontFamily: "monospace", fontSize: 12, marginTop: 2 }}>{serieNumero}</Tag>}
                      {controlAsistencia && credenciales && (
                        <Tooltip title={`Reloj checador: ${statusGeneral}`}>
                          <Tag color={statusGeneral === "completo" ? "success" : statusGeneral === "parcial" ? "warning" : "default"} style={{ fontSize: 10 }}>
                            {statusGeneral === "completo" ? "✓ Reloj" : statusGeneral === "parcial" ? "~ Reloj" : "Sin reloj"}
                          </Tag>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                  <Col span={11} style={embebido ? { display: "none" } : undefined}>
                    <FormItem label="Código" name="codigo" margin required labelCol={LBL} wrapperCol={WRP} getValueFromEvent={soloDigitos}><InputItem placeholder="Código empleado" inputMode="numeric" /></FormItem>
                    <FormItem label="Nombre(s)" name="nombre" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Nombre(s)" /></FormItem>
                    <FormItem label="Ap. Paterno" name="apellidoPaterno" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Apellido Paterno" /></FormItem>
                    <FormItem label="Ap. Materno" name="apellidoMaterno" margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Apellido Materno" /></FormItem>
                    <FormItem label="RFC" name="rfc" margin rfc labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="RFC" suffix={<CalculadoraRfc obtenerForm={() => this.formRef.current} />} /></FormItem>
                    <FormItem label="CURP" name="curp" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="CURP" suffix={<CalculadoraCurp obtenerForm={() => this.formRef.current} />} /></FormItem>
                    <FormItem label="Correo" name="correoElectronico" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="correo@empresa.com" /></FormItem>
                  </Col>
                  <Col span={embebido ? 24 : 11} className={embebido ? "captura-empleado-rejilla" : undefined}>
                    <FormItem label="Fecha Alta" name="fechaAlta" margin required={this.requerido("fechaAlta")} labelCol={LBL} wrapperCol={WRP}><DatePickerItem placeholder="Fecha de alta" style={{ width: "100%" }} /></FormItem>
                    {/* Antes no había control para este campo, y sólo lo escribían el importador
                        externo y las ediciones masivas: un valor aquí era INVISIBLE y aun así le
                        ganaba a la fecha de alta en el CFDI, el recibo, el aguinaldo y el
                        finiquito. De ahí venía el "el finiquito me marca otra fecha de alta". */}
                    {/* Con reingresos registrados la fecha la escribe SÓLO el flujo de Reingreso
                        (el backend rechaza moverla desde aquí): borrarla deshacía la relación
                        nueva sin decirlo. */}
                    <FormItem
                      label="Fecha Reingreso" name="fechaReingreso" margin
                      labelCol={LBL} wrapperCol={WRP}
                      tooltip={this.state.reingresos.length
                        ? "La registró el flujo de Reingreso y sólo él la cambia. Es el inicio de la relación laboral vigente."
                        : "Si es posterior a la fecha de alta, ÉSTA es la que se usa como inicio de la relación laboral en el CFDI de nómina, el recibo, el aguinaldo y el finiquito. Déjala vacía si el empleado nunca se reincorporó."}
                    >
                      <DatePickerItem
                        placeholder="Sin reingreso"
                        style={{ width: "100%" }}
                        allowClear={!this.state.reingresos.length}
                        disabled={this.state.reingresos.length > 0}
                      />
                    </FormItem>
                    {this.renderAvisoRelacionLaboral()}
                    {nomina && (
                      <>
                        <FormItem label="Tipo Contrato" name="tipoContratoId" margin required={this.requerido("tipoContratoId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de contrato">{this.state.objetoTiposContrato}</SelectItem></FormItem>
                        <FormItem label="Tipo Periodo" name="tipoPeriodoId" margin required={this.requerido("tipoPeriodoId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de periodo" allowClear>{this.state.objetoTiposPeriodo}</SelectItem></FormItem>
                        <FormItem label="Salario Diario" name="salarioDiario" margin required={this.requerido("salarioDiario")} rules={this.reglas("salarioDiario")} labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                        <FormItem label="Base Cotización" name="baseDeCotizacion" margin labelCol={LBL} wrapperCol={WRP}>
                          <SelectItem placeholder="Base de cotización"><Option value={1}>Sueldo</Option><Option value={2}>Comisión</Option><Option value={3}>Destajo</Option><Option value={4}>Sueldo-Comisión</Option><Option value={5}>Sueldo-Destajo</Option></SelectItem>
                        </FormItem>
                        <FormItem label="NSS" name="numSeguridadSocial" margin required={this.requerido("numSeguridadSocial")} rules={this.reglas("numSeguridadSocial")} labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="N° Seguridad Social" /></FormItem>
                      </>
                    )}
                  </Col>
                </Row>
                {nomina && (
                  <Row gutter={24} className="captura-empleado-sbc" style={{ marginTop: 10, borderTop: "1px solid #f0f0f0", paddingTop: 10 }}>
                    <Col span={11} offset={1}>
                      <Row gutter={16}>
                        <Col span={12}><FormItem label="SBC Fija" name="sbcParteFija" margin required={this.requerido("sbcParteFija")} rules={this.reglas("sbcParteFija")} labelCol={LBL} wrapperCol={WRP}
                          extra={this.state.sbcAuto ? <span style={{ fontSize: 11 }}>{this.state.sbcAuto}</span> : undefined}
                          tooltip="Se calcula solo al capturar el salario diario: salario × factor de integración de su tipo de prestación. F10 lo recalcula."><InputNumberItem placeholder="0.00" min={0} /></FormItem></Col>
                        <Col span={12}><FormItem label="SBC Variable" name="sbcParteVariable" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem></Col>
                      </Row>
                    </Col>
                    <Col span={11}>
                      <Row gutter={16}>
                        <Col span={12}><FormItem label="SBC (25 UMAS)" name="sbcTopado25UMAS" margin labelCol={LBL} wrapperCol={WRP}
                          tooltip={`Se calcula solo: SBC fija + variable, con tope de 25 UMAs${this.state.umaVigente ? ` (UMA $${this.state.umaVigente})` : ""}. F10 lo recalcula.`}>
                          <InputNumberItem placeholder="0.00" min={0} /></FormItem></Col>
                        <Col span={6}><FormItem name="externo" label="Externo" margin initialValue={false} valuePropName="checked"><SwitchItem /></FormItem></Col>
                        <Col span={6}><FormItem name="sindicalizado" label="Sind." margin initialValue={false} valuePropName="checked"><SwitchItem /></FormItem></Col>
                      </Row>
                    </Col>
                  </Row>
                )}
              </div>

              {/* TABS. Embebido, la pestaña la elige el asistente y la barra no se pinta: las
                  pestañas con forceRender siguen montadas aunque no se vean. */}
              <div style={embebido && !seccion.tab ? { display: "none" } : undefined}>
              <Tabs
                defaultActiveKey="1" onChange={this.onCambiarTab}
                {...(embebido ? { activeKey: seccion.tab || "1", renderTabBar: () => <div /> } : {})}
              >

                {/* PRIMER TAB: "Generales" si nomina, "General" si no */}
                <TabPane tab={nomina ? "Generales" : "General"} key="1" forceRender>
                  {this.renderPrimerTab()}
                </TabPane>

                {/* Domicilio */}
                <TabPane tab="Domicilio" key="2" forceRender>
                  <Row gutter={24}>
                    <Col span={12}>
                      <FormItem label="Código Postal" name="coloniaId" margin required={this.requerido("coloniaId")} labelCol={LBL} wrapperCol={WRP}>
                        <SelectItem placeholder="Colonia" onSearch={this.onSearchColonia.bind(this)} onSelect={this.onSelectColoniaId.bind(this)}>
                          {this.state.objetoColonias === null ? <Option disabled>Elija primero un municipio</Option> : this.state.objetoColonias}
                          <Option disabled>Busque por código postal</Option>
                        </SelectItem>
                      </FormItem>
                      <FormItem label="Municipio" name="municipioId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Municipio" onChange={this.onChangeMunicipio.bind(this)}>{this.state.objetoMunicipios === null ? <Option disabled>Elija primero un estado</Option> : this.state.objetoMunicipios}</SelectItem></FormItem>
                      <FormItem label="Estado" name="estadoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Estado" onChange={this.onChangeEstado.bind(this)}>{this.state.objetoEstados}</SelectItem></FormItem>
                      <FormItem label="País" name="paisId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="País">{this.state.objetoPaises}</SelectItem></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem name="colonia" label="Colonia" margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Colonia" /></FormItem>
                      <FormItem label="Calle" name="calle" max={200} margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Calle" /></FormItem>
                      <FormItem label="Número" name="numeroCalle" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Número" numeroCalle /></FormItem>
                      <FormItem label="Núm. Interior" name="numeroInterior" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Número Interior" numeroCalle /></FormItem>
                      <FormItem label="Referencia" name="referencia" margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Referencia" /></FormItem>
                    </Col>
                  </Row>
                </TabPane>

                {/* Tabs de nómina */}
                {nomina && (
                  <>
                    <TabPane tab="IMSS - Infonavit" key="4" forceRender>
                      <Row gutter={24}>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Datos IMSS</Divider>
                          <FormItem label="N° Seg. Social" name="numSeguridadSocial" margin required={this.requerido("numSeguridadSocial")} rules={this.reglas("numSeguridadSocial")} labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="NSS" /></FormItem>
                          <FormItem label="Registro Patronal" name="registroPatronalId" margin required={this.requerido("registroPatronalId")} labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Registro patronal">{this.state.objetoRegistrosPatronales}</SelectItem></FormItem>
                          <FormItem label="UMF" name="umf" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="UMF" /></FormItem>
                          <FormItem label="Nombre del Padre" name="nombrePadre" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Nombre del padre" /></FormItem>
                          <FormItem label="Nombre de la Madre" name="nombreMadre" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Nombre de la madre" /></FormItem>
                          <FormItem label="Estado Civil" name="estadoCivil" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Estado civil"><Option value={1}>Soltero</Option><Option value={2}>Casado</Option><Option value={3}>Concubinato</Option><Option value={4}>Unión Civil</Option><Option value={5}>Viudo</Option><Option value={6}>Divorciado</Option></SelectItem></FormItem>
                          <FormItem label="Avisos Pendientes" name="avisosPendientes" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Avisos pendientes"><Option value="alta">Alta</Option><Option value="baja">Baja</Option><Option value="modifSalario">Modificación de Salario</Option></SelectItem></FormItem>
                          <FormItem label="Última Baja" name="ultimaBaja" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Última baja" /></FormItem>
                        </Col>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Datos Personales</Divider>
                          <FormItem label="Sexo" name="sexo" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Sexo"><Option value="Hombre">Hombre</Option><Option value="Mujer">Mujer</Option><Option value="No Aplica">No Aplica</Option></SelectItem></FormItem>
                          <FormItem label="Fecha Nacimiento" name="fechaNacimiento" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Fecha de nacimiento" /></FormItem>
                          <FormItem label="Estado Nacimiento" name="estadoNacimientoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Estado de nacimiento">{this.state.objetoEstadosNacimiento}</SelectItem></FormItem>
                          <FormItem label="Ciudad Nacimiento" name="ciudadNacimientoId" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Ciudad de nacimiento" /></FormItem>
                          <FormItem label="CURP" name="curp" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="CURP" suffix={<CalculadoraCurp obtenerForm={() => this.formRef.current} />} /></FormItem>
                          <FormItem name="extranjeroSinCurp" label="Sin CURP" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane tab="Sueldos y Salarios" key="5" forceRender>
                      <Row gutter={24}>
                        <Col span={12}>
                          <FormItem label="Salario Variable" name="salarioVariable" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                          <FormItem label="Fecha Sal. Variable" name="fechaSalarioVariable" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                          <FormItem label="Salario Promedio" name="salarioPromedio" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                          <FormItem label="Fecha Sal. Promedio" name="fechaSalarioPromedio" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem label="Sal. Base Liquid." name="salarioBaseLiquidacion" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                          <FormItem label="Saldo Ajuste Neto" name="saldoAjusteNeto" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" /></FormItem>
                          <FormItem label="Fecha Sal. Diario" name="fechaSalarioDiario" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                          <FormItem label="Fecha Sal. Integrado" name="fechaSalarioIntegrado" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane tab="Pagos y Extras" key="6" forceRender>
                      <Row gutter={24}>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Pagos Bancarios</Divider>
                          <FormItem label="Banco" name="bancoPagoElectronicoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Banco">{this.state.objetoBancos}</SelectItem></FormItem>
                          <FormItem label="Sucursal" name="sucursalPagoElectronico" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Sucursal" /></FormItem>
                          <FormItem label="N° Cuenta" name="numCuenta" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Número de cuenta" /></FormItem>
                          <FormItem label="CLABE" name="clabeInterbancaria" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="CLABE 18 dígitos" /></FormItem>
                        </Col>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Extras</Divider>
                          <FormItem label="Extra 1" name="extra1" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Extra 1" /></FormItem>
                          <FormItem label="Núm. Extra 1" name="numExtra1" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0" /></FormItem>
                        </Col>
                      </Row>
                    </TabPane>

                    {/* forceRender NO se puede quitar: sin él el Form.List de conceptosIds no
                        se monta, no viaja en los values del submit y el reemplazo por régimen
                        se vuelve un no-op silencioso (el empleado quedaría como asimilado
                        conservando Sueldo e IMSS). */}
                    <TabPane tab="Conceptos" key="9" forceRender>
                      {this.state.esAsimilado && (
                        <Alert
                          type="info"
                          showIcon
                          style={{ marginBottom: 12 }}
                          message="Empleado asimilado a salarios"
                          description="No le corresponden Sueldo, Séptimo Día, cuotas del IMSS ni subsidio al empleo. Los conceptos de ISR de la lista son los que calculan su retención: si los quitas, el impuesto sale mal."
                        />
                      )}
                      {/* PTU y Aguinaldo */}
                      <Row gutter={24} style={{ marginBottom: 4 }}>
                        <Col span={12}>
                          <FormItem name="calculoPTU" label="Cálculo PTU" margin initialValue={true} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}
                            tooltip="Al activar, este empleado participará en el cálculo de PTU">
                            <SwitchItem />
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem name="calculoAguinaldo" label="Cálculo Aguinaldo" margin initialValue={true} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}
                            tooltip="Al activar, se calculará aguinaldo para este empleado">
                            <SwitchItem />
                          </FormItem>
                        </Col>
                      </Row>

                      {this.state.esAsimilado && this.state.asimilados?.percepcionId && (
                        <Row gutter={24} style={{ marginBottom: 4 }}>
                          <Col span={12}>
                            {/* Derivado de conceptosIds, no es un campo del empleado: va sin
                                `name` y con su propio onChange. El shouldUpdate es lo que lo
                                vuelve a pintar cuando la lista cambia — setFieldsValue no
                                re-renderiza el componente por sí solo. */}
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => (
                                <FormItem
                                  label="Ingreso en cada nómina"
                                  margin
                                  labelCol={LBL}
                                  wrapperCol={WRP}
                                  tooltip="Activado, el concepto de ingreso de asimilados entra solo en cada nómina que se abra (con importe en cero, para que lo captures). Desactivado, hay que agregarlo a mano en el sobre-recibo cada vez que se le pague."
                                >
                                  <SwitchItem
                                    checked={percepcionIncluida(
                                      getFieldValue("conceptosIds"),
                                      this.state.asimilados.percepcionId
                                    )}
                                    onChange={this.onCambiarIncluirAsimilados}
                                  />
                                </FormItem>
                              )}
                            </FormItem>
                          </Col>
                        </Row>
                      )}

                      <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>
                        Conceptos asignados al empleado
                      </Divider>

                      <Form.List name="conceptosIds">
                        {(fields, { add, remove, move }) => (
                          <>
                            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <colgroup>
                                <col />
                                <col style={{ width: 96 }} />
                                <col style={{ width: 108 }} />
                                <col style={{ width: 52 }} />
                                <col style={{ width: 36 }} />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th style={thStyle}>Concepto</th>
                                  <th style={{ ...thStyle, textAlign: "center" }}>Clave</th>
                                  <th style={{ ...thStyle, textAlign: "center" }}>Tipo</th>
                                  <th style={thStyle} />
                                  <th style={thStyle} />
                                </tr>
                              </thead>
                              <tbody>
                                {fields.length === 0 ? (
                                  <tr>
                                    {/* Para un asimilado esto no es un estado neutro: "todos"
                                        incluye Sueldo e IMSS, que no le corresponden. El
                                        guardado lo rechaza, y aquí se avisa antes. */}
                                    <td colSpan={5} style={{ ...tdStyle, textAlign: "center", padding: "18px 0", color: this.state.esAsimilado ? "#a8071a" : "var(--color-text-secondary)", fontSize: 12 }}>
                                      {this.state.esAsimilado ? (
                                        <>
                                          Sin conceptos — a un asimilado a salarios <strong>no</strong> se le puede dejar la lista vacía:
                                          significa <strong>todos</strong> los conceptos, Sueldo e IMSS incluidos. Vuelve a elegir su
                                          Tipo de Régimen en Generales para que se le propongan.
                                        </>
                                      ) : (
                                        <>Sin conceptos — al calcular se usarán <strong>todos</strong> los activos de la empresa</>
                                      )}
                                    </td>
                                  </tr>
                                ) : (
                                  fields.map(({ key, name, ...restField }, index) => (
                                    <FormItem key={key} shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        const conceptoId = getFieldValue(["conceptosIds", name]);
                                        const concepto = this.state.todasConceptos.find(c => c._id?.toString() === conceptoId?.toString());
                                        const tipoCfg = {
                                          1: { label: "Percepción", color: "#3B6D11", bg: "#EAF3DE" },
                                          2: { label: "Deducción", color: "#A32D2D", bg: "#FCEBEB" },
                                          3: { label: "Obligación", color: "#185FA5", bg: "#E6F1FB" },
                                        };
                                        const tipo = tipoCfg[concepto?.tipo];
                                        const deshabilitado = concepto && concepto.estado !== 1;
                                        const rowBg = deshabilitado ? "#FAEEDA30" : "var(--color-background-primary)";
                                        return (
                                          <tr style={{ background: rowBg }}>
                                            {/* Concepto */}
                                            <td style={{ ...tdStyle, padding: "2px 4px" }}>
                                              <FormItem {...restField} name={name} noStyle required>
                                                <SelectItem placeholder="Seleccionar concepto..." showSearch width="100%"
                                                  filterOption={(input, option) =>
                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                  }>
                                                  {this.state.todasConceptos.filter(c => c.estado === 1).map(c => (
                                                    <Option value={c._id} key={c._id}>
                                                      {c.serie + "-" + c.numero + " | " + c.descripcion}
                                                    </Option>
                                                  ))}
                                                </SelectItem>
                                              </FormItem>
                                            </td>
                                            {/* Clave */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              {concepto ? (
                                                <span style={{ fontFamily: "monospace", fontSize: 11, background: "var(--color-background-secondary)", border: "1px solid var(--color-border-tertiary)", borderRadius: 4, padding: "2px 7px", color: "var(--color-text-secondary)" }}>
                                                  {concepto.serie + "-" + concepto.numero}
                                                </span>
                                              ) : <span style={{ color: "var(--color-text-secondary)", fontSize: 12 }}>—</span>}
                                            </td>
                                            {/* Tipo */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              {tipo ? (
                                                <span style={{ fontSize: 11, fontWeight: 500, padding: "2px 9px", borderRadius: 999, background: tipo.bg, color: tipo.color }}>
                                                  {tipo.label}
                                                </span>
                                              ) : deshabilitado ? (
                                                <span style={{ fontSize: 11, fontWeight: 500, padding: "2px 9px", borderRadius: 999, background: "#FAEEDA", color: "#854F0B" }}>
                                                  Deshabilitado
                                                </span>
                                              ) : <span style={{ color: "var(--color-text-secondary)", fontSize: 12 }}>—</span>}
                                            </td>
                                            {/* Reordenar */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                                                <UpOutlined
                                                  style={{ fontSize: 11, color: index === 0 ? "#d9d9d9" : "var(--color-text-secondary)", cursor: index === 0 ? "not-allowed" : "pointer" }}
                                                  onClick={() => index > 0 && move(index, index - 1)}
                                                />
                                                <DownOutlined
                                                  style={{ fontSize: 11, color: index === fields.length - 1 ? "#d9d9d9" : "var(--color-text-secondary)", cursor: index === fields.length - 1 ? "not-allowed" : "pointer" }}
                                                  onClick={() => index < fields.length - 1 && move(index, index + 1)}
                                                />
                                              </div>
                                            </td>
                                            {/* Eliminar */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              <MinusCircleOutlined
                                                style={{ fontSize: 14, color: "var(--color-text-secondary)", cursor: "pointer" }}
                                                onMouseEnter={e => e.target.style.color = "#E24B4A"}
                                                onMouseLeave={e => e.target.style.color = ""}
                                                onClick={() => remove(name)}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      }}
                                    </FormItem>
                                  ))
                                )}
                              </tbody>
                            </table>

                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}
                              style={{ marginTop: 8 }}
                              disabled={this.state.todasConceptos.filter(c => c.estado === 1).length === 0}>
                              Agregar concepto
                            </ButtonItem>
                          </>
                        )}
                      </Form.List>

                      <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 24 }}>
                        Cuentas contables por concepto
                      </Divider>

                      <Form.List name="cuentasContablesConceptos">
                        {(fields, { add, remove }) => (
                          <>
                            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <colgroup>
                                <col />
                                <col />
                                <col style={{ width: 36 }} />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th style={thStyle}>Concepto</th>
                                  <th style={thStyle}>Cuenta Contable</th>
                                  <th style={thStyle} />
                                </tr>
                              </thead>
                              <tbody>
                                {fields.length === 0 ? (
                                  <tr>
                                    <td colSpan={3} style={{ ...tdStyle, textAlign: "center", padding: "18px 0", color: "var(--color-text-secondary)", fontSize: 12 }}>
                                      Este empleado aún no tiene cuentas contables por concepto configuradas
                                    </td>
                                  </tr>
                                ) : (
                                  fields.map(({ key, name, ...restField }) => (
                                    <tr key={key}>
                                      {/* Concepto */}
                                      <td style={{ ...tdStyle, padding: "2px 4px" }}>
                                        <FormItem {...restField} name={[name, "conceptoNominaId"]} noStyle required>
                                          <SelectItem placeholder="Seleccionar concepto..." showSearch width="100%"
                                            filterOption={(input, option) =>
                                              option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }>
                                            {this.state.todasConceptos.filter(c => c.estado === 1).map(c => (
                                              <Option value={c._id} key={c._id}>
                                                {c.serie + "-" + c.numero + " | " + c.descripcion}
                                              </Option>
                                            ))}
                                          </SelectItem>
                                        </FormItem>
                                      </td>
                                      {/* Cuenta Contable */}
                                      <td style={{ ...tdStyle, padding: "2px 4px" }}>
                                        <FormItem {...restField} name={[name, "cuentaContableId"]} noStyle required>
                                          <SelectItem placeholder="Seleccionar cuenta contable..." showSearch width="100%"
                                            filterOption={(input, option) =>
                                              option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }>
                                            {this.state.todasCuentasContables.map(c => (
                                              <Option value={c._id} key={c._id}>
                                                {cuentaMask(c.nivel1 + c.nivel2 + c.nivel3 + c.nivel4 + c.nivel5) + " - " + c.descripcion}
                                              </Option>
                                            ))}
                                          </SelectItem>
                                        </FormItem>
                                      </td>
                                      {/* Eliminar */}
                                      <td style={{ ...tdStyle, textAlign: "center" }}>
                                        <MinusCircleOutlined
                                          style={{ fontSize: 14, color: "var(--color-text-secondary)", cursor: "pointer" }}
                                          onMouseEnter={e => e.target.style.color = "#E24B4A"}
                                          onMouseLeave={e => e.target.style.color = ""}
                                          onClick={() => remove(name)}
                                        />
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>

                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}
                              style={{ marginTop: 8 }}
                              disabled={this.state.todasConceptos.filter(c => c.estado === 1).length === 0 || this.state.todasCuentasContables.length === 0}>
                              Agregar cuenta contable por concepto
                            </ButtonItem>
                          </>
                        )}
                      </Form.List>
                    </TabPane>

                    <TabPane tab="Historial de Sueldos" key="10" forceRender>
                      {(() => {
                        const historial = this.formRef.current?.getFieldValue('historialSalario') || [];

                        const TH = {
                          padding: '6px 10px', fontSize: 11, fontWeight: 600,
                          textAlign: 'center', border: '1px solid #b8a000',
                          whiteSpace: 'nowrap', color: '#fff', background: '#c9a227',
                        };
                        const THG = { ...TH, background: '#5a7a8a', border: '1px solid #4a6a7a' };
                        const TD = {
                          border: '1px solid #e0e0e0', padding: '6px 10px',
                          textAlign: 'center', fontSize: 12, verticalAlign: 'middle',
                        };

                        const tipoLabel = {
                          fija: 'Salario diario',
                          variable: 'SBC parte variable',
                          integrado: 'SBC integrado',
                        };

                        const tipoColor = {
                          fija: '#2d7d46',
                          variable: '#7b4fa8',
                          integrado: '#1a5fa8',
                        };

                        if (historial.length === 0) {
                          return (
                            <div style={{ textAlign: 'center', color: '#aaa', padding: 40, fontSize: 13 }}>
                              Sin registros de aumentos de sueldo todavía.
                            </div>
                          );
                        }

                        const sorted = [...historial].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
                        const fmt = (n) => n != null ? `$${Number(n).toFixed(2)}` : '—';

                        return (
                          <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 600 }}>
                              <thead>
                                <tr>
                                  <th style={THG}>Fecha</th>
                                  <th style={THG}>Tipo</th>
                                  <th style={THG}>Anterior</th>
                                  <th style={THG}>Nuevo</th>
                                  <th style={THG}>Motivo</th>
                                </tr>
                              </thead>
                              <tbody>
                                {sorted.map((h, i) => {
                                  const color = tipoColor[h.tipo] || '#333';
                                  return (
                                    <tr key={i} style={{ background: i % 2 === 0 ? 'var(--color-background-primary)' : '#fffde7' }}>
                                      <td style={TD}>
                                        {h.fecha ? moment(h.fecha).format('DD/MM/YYYY') : '—'}
                                      </td>
                                      <td style={{ ...TD, color, fontWeight: 600 }}>
                                        {tipoLabel[h.tipo] || h.tipo || '—'}
                                      </td>
                                      <td style={{ ...TD, fontFamily: 'monospace', color: '#999', textDecoration: 'line-through' }}>
                                        {fmt(h.anterior)}
                                      </td>
                                      <td style={{ ...TD, fontFamily: 'monospace', fontWeight: 600, color }}>
                                        {fmt(h.nuevo)}
                                      </td>
                                      <td style={{ ...TD, textAlign: 'left', color: '#555' }}>
                                        {h.motivo || '—'}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        );
                      })()}
                    </TabPane>
                  </>
                )}

                {/* Control Asistencia */}
                {controlAsistencia && (
                  <TabPane tab={<span><ScanOutlined /> Control Asistencia</span>} key="8" forceRender>
                    <div style={{
                      background: statusGeneral === "completo" ? "#f6ffed" : statusGeneral === "parcial" ? "#fffbe6" : "#fafafa",
                      border: `1px solid ${statusGeneral === "completo" ? "#b7eb8f" : statusGeneral === "parcial" ? "#ffe58f" : "#e8e8e8"}`,
                      borderRadius: 6, padding: "10px 16px", marginBottom: 20,
                      display: "flex", alignItems: "center", gap: 10
                    }}>
                      <SafetyCertificateOutlined style={{ fontSize: 20, color: statusGeneral === "completo" ? "#52c41a" : statusGeneral === "parcial" ? "#faad14" : "#bbb" }} />
                      <span style={{ fontSize: 13, color: "#555" }}>
                        Estado del reloj checador:
                        <Tag color={statusGeneral === "completo" ? "success" : statusGeneral === "parcial" ? "warning" : "default"} style={{ marginLeft: 8 }}>
                          {statusGeneral === "completo" ? "Completo" : statusGeneral === "parcial" ? "Parcial" : "Sin datos"}
                        </Tag>
                      </span>
                      {credenciales?.actualizadoAt && (
                        <span style={{ fontSize: 11, color: "#aaa", marginLeft: "auto" }}>Actualizado: {moment(credenciales.actualizadoAt).format("DD/MM/YYYY HH:mm")}</span>
                      )}
                    </div>
                    <Row gutter={24}>
                      <Col span={8}>
                        <CredencialCard icon={<EyeOutlined />} titulo="Reconocimiento Facial" activo={tieneRostro} color="#1677ff"
                          detalle={tieneRostro
                            ? `${rostros.length} plantilla${rostros.length > 1 ? "s" : ""} registrada${rostros.length > 1 ? "s" : ""}${ultimoRostro?.fuente?.sn ? ` · Reloj: ${ultimoRostro.fuente.sn}` : ""}`
                            : null}
                          updatedAt={ultimoRostro?.updatedAt} />
                      </Col>
                      <Col span={8}>
                        <CredencialCard icon={<ScanOutlined />} titulo="Huella Digital" activo={huellas.length > 0} color="#722ed1"
                          detalle={huellas.length > 0 ? `${huellas.length} dedo${huellas.length > 1 ? "s" : ""} registrado${huellas.length > 1 ? "s" : ""}` : null}
                          updatedAt={huellas.length > 0 ? huellas[huellas.length - 1]?.updatedAt : null} />
                      </Col>
                      <Col span={8}>
                        <CredencialCard icon={<LockOutlined />} titulo="Contraseña" activo={tienePassword} color="#fa8c16" updatedAt={credenciales?.passwordUpdatedAt} />
                      </Col>
                    </Row>
                    {rostros.length > 1 && (
                      <>
                        <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 20 }}>Plantillas de Rostro Registradas</Divider>
                        <Row gutter={12}>
                          {rostros.map((r, idx) => (
                            <Col key={idx} span={4}>
                              <div style={{ border: "1px solid #1677ff33", borderRadius: 6, padding: "10px", background: "#1677ff08", textAlign: "center" }}>
                                <EyeOutlined style={{ color: "#1677ff", fontSize: 20 }} />
                                <div style={{ fontSize: 11, marginTop: 4, color: "#555", fontWeight: 600 }}>No {r.no ?? idx}</div>
                                <Tag color="blue" style={{ fontSize: 10, marginTop: 4 }}>✓ Registrado</Tag>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </>
                    )}
                    {huellas.length > 0 && (
                      <>
                        <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 20 }}>Dedos Registrados</Divider>
                        <Row gutter={12}>
                          {huellas.map((h, idx) => (
                            <Col key={idx} span={4}>
                              <div style={{ border: "1px solid #722ed133", borderRadius: 6, padding: "10px", background: "#722ed108", textAlign: "center" }}>
                                <ScanOutlined style={{ color: "#722ed1", fontSize: 20 }} />
                                <div style={{ fontSize: 11, marginTop: 4, color: "#555", fontWeight: 600 }}>FID {h.fid}</div>
                                <Tag color="purple" style={{ fontSize: 10, marginTop: 4 }}>✓ Registrado</Tag>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </>
                    )}
                    {this.props.appMovil && this.props.checadaRemota && (
                      <>
                        <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 20 }}>Checada remota (app)</Divider>
                        <Row gutter={24}>
                          <Col span={12}>
                            <FormItem name="permiteChecadaRemota" label="Permitir checada remota (app)" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP} tooltip="El empleado podrá registrar su entrada y salida desde la app móvil, solo dentro de los perímetros asignados">
                              <SwitchItem />
                            </FormItem>
                          </Col>
                          <Col span={12}>
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => getFieldValue("permiteChecadaRemota") && (
                                <FormItem label="Perímetros" name="perimetrosChecadaIds" margin labelCol={LBL} wrapperCol={WRP}
                                  rules={[{ required: true, type: "array", min: 1, message: "Selecciona al menos un perímetro de checada" }]}>
                                  <SelectPerimetrosChecadaItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Perímetros de checada" />
                                </FormItem>
                              )}
                            </FormItem>
                          </Col>
                        </Row>
                        {this.props.verificacionFacial && (
                          <Row gutter={24}>
                            <Col span={12}>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => getFieldValue("permiteChecadaRemota") && (
                                  <FormItem name="verificacionFacialChecada" label="Verificar rostro al checar" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP} tooltip="Al checar, la app compara la cara del empleado contra su fotografía. Sin fotografía cargada no podrá checar">
                                    <SwitchItem />
                                  </FormItem>
                                )}
                              </FormItem>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </TabPane>
                )}

                {/* Contactos */}
                <TabPane tab="Contactos" key="11" forceRender>
                  <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 0 }}>Teléfonos</Divider>
                  <Form.List name="telefonos">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={16} style={{ marginBottom: 8 }}>
                            <Col span={8}>
                              <FormItem {...restField} name={[name, "descripcion"]} label="Descripción" rules={[{ required: true, message: "Ingresa la descripción" }]}>
                                <InputItem placeholder="Ej. Celular, Trabajo" />
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem {...restField} name={[name, "numero"]} label="Número" rules={[{ required: true, message: "Ingresa el número" }]}>
                                <InputItem placeholder="Ej. 5512345678" />
                              </FormItem>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined style={{ fontSize: 18, color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <Row style={{ marginBottom: 16 }}>
                          <Col span={24}>
                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>Añadir Teléfono</ButtonItem>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Form.List>

                  <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Contactos de Emergencia</Divider>
                  <Form.List name="contactosEmergencia">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={16} style={{ marginBottom: 8 }}>
                            <Col span={8}>
                              <FormItem {...restField} name={[name, "nombre"]} label="Nombre" rules={[{ required: true, message: "Ingresa el nombre" }]}>
                                <InputItem placeholder="Nombre completo" />
                              </FormItem>
                            </Col>
                            <Col span={6}>
                              <FormItem {...restField} name={[name, "parentesco"]} label="Parentesco" rules={[{ required: true, message: "Ingresa el parentesco" }]}>
                                <InputItem placeholder="Ej. Esposa, Padre" />
                              </FormItem>
                            </Col>
                            <Col span={7}>
                              <FormItem {...restField} name={[name, "telefono"]} label="Teléfono" rules={[{ required: true, message: "Ingresa el teléfono" }]}>
                                <InputItem placeholder="Ej. 5512345678" />
                              </FormItem>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined style={{ fontSize: 18, color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <Row>
                          <Col span={24}>
                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ marginBottom: 10 }}>Añadir Contacto de Emergencia</ButtonItem>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Form.List>
                </TabPane>

                {/* Documentos */}
                <TabPane tab="Documentos" key="7" forceRender>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      if (getFieldValue("chofer")) {
                        return (
                          <>
                            <Row style={{ marginBottom: 10 }}><Col span={24}><Alert message="Datos obtenidos de la Licencia del Chofer" description="Para modificar esta información, favor de hacerlo en la pestaña General." type="info" showIcon /></Col></Row>
                            <Row gutter={16} style={{ marginBottom: 12, opacity: 0.8 }}>
                              <Col span={6}><FormItem label="Descripción" margin><InputItem disabled value={getFieldValue("numLicencia") || "Licencia"} /></FormItem></Col>
                              <Col span={5}><FormItem label="Tipo" margin><InputItem disabled value="Licencia de Chofer" /></FormItem></Col>
                              <Col span={5}><FormItem label="Vencimiento" margin><DatePickerItem disabled style={{ width: "100%" }} format="DD-MM-YYYY" value={getFieldValue("vigenciaLicencia")} /></FormItem></Col>
                            </Row>
                          </>
                        );
                      }
                      return null;
                    }}
                  </FormItem>
                  <Form.List name="documentos">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={16} style={{ marginBottom: 12 }}>
                            <Col span={6}><FormItem {...restField} name={[name, "descripcion"]} label="Descripción" rules={[{ required: true, message: "Ingresa la descripción" }]}><InputItem placeholder="Ej. Licencia Estatal" /></FormItem></Col>
                            <Col span={5}><FormItem {...restField} name={[name, "tipo"]} label="Tipo" rules={[{ required: true, message: "Ingresa el tipo" }]}><InputItem placeholder="Ej. Apta Médica" /></FormItem></Col>
                            <Col span={5}><FormItem {...restField} name={[name, "vencimiento"]} label="Vencimiento"><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Fecha de vencimiento" /></FormItem></Col>
                            <Col span={6}>
                              <FormItem
                                {...restField}
                                name={[name, "archivo"]}
                                label="Archivo"
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                tooltip={`PDF o imagen, máximo ${MAX_ARCHIVOS_DOCUMENTOS} archivos por empleado`}
                              >
                                <Upload
                                  accept=".pdf,.jpg,.jpeg,.png,.webp"
                                  maxCount={1}
                                  beforeUpload={(file) => this.beforeUploadDocumento(file, name)}
                                  onPreview={this.handlePreviewDocumento}
                                  showUploadList={{ showRemoveIcon: true, removeIcon: <DeleteOutlined style={{ color: "red" }} /> }}
                                >
                                  <FormItem noStyle shouldUpdate>
                                    {({ getFieldValue }) => {
                                      const documentos = getFieldValue("documentos") || [];
                                      if (documentos[name]?.archivo?.length > 0) return null;
                                      const totalConArchivo = documentos.filter((d) => d?.archivo?.length > 0).length;
                                      if (totalConArchivo >= MAX_ARCHIVOS_DOCUMENTOS) return null;
                                      return <ButtonItem type="dashed" size="small" icon={<UploadOutlined />}>Subir</ButtonItem>;
                                    }}
                                  </FormItem>
                                </Upload>
                              </FormItem>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined style={{ fontSize: 18, color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <Row><Col span={24}><ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ marginTop: 10, marginBottom: 10 }}>Añadir Documento</ButtonItem></Col></Row>
                      </>
                    )}
                  </Form.List>
                </TabPane>

                {/*
                  Créditos y movimientos del empleado.

                  A diferencia de todas las pestañas de arriba, éstas NO llevan `forceRender` y no
                  tienen ni un solo campo del formulario: cada una es un CRUD autónomo que guarda
                  contra sus propios endpoints en el momento, sin pasar por el botón "Editar
                  Empleado". `forceRender` es obligatorio donde hay FormItem (un campo que nunca se
                  montó no viaja en los `values` del submit); aquí sólo serviría para disparar seis
                  peticiones de más cada vez que alguien abre a un empleado.

                  Son los mismos componentes que usa el Sobre Recibo de la prenómina.

                  OJO al tocarlos: acaban DENTRO del <Form> de esta pantalla, y un <button> sin
                  `type` es type="submit" por HTML. En el Sobre Recibo viven en un modal y no se
                  nota, pero aquí un botón sin `type="button"` guarda al empleado y sale de la
                  pantalla en cuanto lo presionas. Todo <button> nativo de esos seis archivos lleva
                  `type="button"` por eso. (Los ButtonItem no: antd ya usa htmlType="button".)
                */}
                {nomina && (
                  <>
                    <TabPane tab="Créditos INFONAVIT" key="12">
                      {this.state.tabsVisitadas["12"] && (
                        <InfonvitEmpleado empleadoId={this.state.id} />
                      )}
                    </TabPane>

                    <TabPane tab="Créditos FONACOT" key="13">
                      {this.state.tabsVisitadas["13"] && (
                        <FonacotEmpleado empleadoId={this.state.id} />
                      )}
                    </TabPane>

                    <TabPane tab="Mov. Permanentes" key="14">
                      {this.state.tabsVisitadas["14"] && (
                        <MovimientosPermanentesEmpleado empleadoId={this.state.id} />
                      )}
                    </TabPane>

                    <TabPane tab="Incid. Permanentes" key="15">
                      {this.state.tabsVisitadas["15"] && (
                        <IncidenciasPermanentesAutonomo
                          empleadoId={this.state.id}
                          tipoPeriodoId={this.formRef.current?.getFieldValue("tipoPeriodoId")}
                        />
                      )}
                    </TabPane>

                    <TabPane tab="Incapacidades" key="16">
                      {this.state.tabsVisitadas["16"] && (
                        <IncapacidadesEmpleado
                          empleadoId={this.state.id}
                          salarioDiario={this.formRef.current?.getFieldValue("salarioDiario")}
                        />
                      )}
                    </TabPane>
                  </>
                )}

                {/* Sin `periodoId` el componente entra en su modo "perfil": kárdex + historial.
                    Va fuera del bloque `nomina` igual que el ítem Vacaciones del menú. */}
                <TabPane tab="Vacaciones" key="17">
                  {this.state.tabsVisitadas["17"] && (
                    <VacacionesEmpleado empleadoId={this.state.id} />
                  )}
                </TabPane>
              </Tabs>
              </div>
            </Form>
          </Spin>
        </div>
        <ModalUsuarioMovil
          visible={this.state.modalUsuarioMovil}
          onCancel={() => this.setState({ modalUsuarioMovil: false })}
          onSuccess={() => this.setState({ modalUsuarioMovil: false })}
          tipo="EMPLEADO"
          referenciaId={this.state.id}
          nombreSugerido={this.formRef.current?.getFieldValue("nombre")}
          correoSugerido={this.formRef.current?.getFieldValue("correo")}
        />
        <ModalPrevisualizarArchivos
          file={this.state.currentPreviewFile}
          empleadoId={this.state.id}
          visible={this.state.filePreviewVisible}
          onClose={this.handleCloseFilePreview}
        />
        <ModalValidacionTimbrado
          visible={this.state.validacion.visible}
          loading={this.state.validacion.loading}
          resultados={this.state.validacion.resultados}
          aviso="Se está revisando lo que tienes capturado en pantalla, incluyendo los cambios que no has guardado."
          onCancel={() => this.setState({ validacion: { visible: false, loading: false, resultados: [] } })}
          onDescargarXml={() => this.descargarXmlPrueba()}
        />
        <ModalHistorialRelacionLaboral
          visible={this.state.historialRelacionLaboralVisible}
          onCancel={() => this.setState({ historialRelacionLaboralVisible: false })}
          empleadoId={this.state.id}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          nombreEmpleado={[
            this.formRef.current?.getFieldValue("nombre"),
            this.formRef.current?.getFieldValue("apellidoPaterno"),
          ].filter(Boolean).join(" ")}
        />
        <ModalReingreso
          visible={this.state.modalReingresoVisible}
          empleadoId={this.state.id}
          onCerrar={(reingresado) => {
            this.setState({ modalReingresoVisible: false });
            // Recarga lo guardado: estado, fechas, salario y el aviso del finiquito anterior.
            if (reingresado) this.consultarTodo();
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  modulosMezcal: state.empresa.modulosMezcal,
  nomina: state.empresa.nomina,
  controlAsistencia: state.empresa.controlAsistencia,
  appMovil: state.empresa.appMovil,
  checadaRemota: state.empresa.checadaRemota,
  verificacionFacial: state.empresa.verificacionFacial,
  permisoUsuarioMovil:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1092812a586012f03f5fbf",
    )?.activado,
  // El mismo del Finiquito y de Deshabilitar en el listado: el reingreso es la otra cara de la baja.
  permisoDeshabilitarEmpleado:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "675096f0798d4e0043687257",
    )?.activado,
});

export default connect(mapStateToProps)(EditarEmpleado);